import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import Text from '../../../Text'
import { BIRDVIEW_META_SEPARATOR } from '../../DashboardBirdview.constants'
import {
  formatBirdviewChartDate,
  formatBirdviewKpiValue,
} from '../../DashboardBirdview.utils.charts'

import * as styles from './BirdviewSparklineTooltip.module.css'

function BirdviewSparklineTooltip({
  active,
  label,
  payload = EMPTY_LIST,
  unit,
}) {
  const { t } = useTranslation()

  const point = payload[0]

  return active && point ? (
    <Text isSecondary className={styles.tooltip}>
      {formatBirdviewChartDate(label)}
      {BIRDVIEW_META_SEPARATOR}
      {formatBirdviewKpiValue({ t, unit, value: point.value })}
    </Text>
  ) : null
}

export default BirdviewSparklineTooltip
